import { h, defineComponent } from 'vue';
// @ts-ignore
import { BDropdown } from 'buefy/dist/esm/dropdown';
import { Button } from '@/ui/components/Button';
import { starsIcon } from '@/ui/components/icon/icons';

interface UpgradeAdDropdownProps {
  placeholder: string;
  classes?: string;
}

export const UpgradeAdDropdown = defineComponent<UpgradeAdDropdownProps>({
  name: 'UpgradeAdDropdownProps',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
    },
  },
  setup(props) {
    return function render() {
      return h('div', { class: `upgrade-ad-dropdown ${props.classes}` },
        [
          h(BDropdown, {
            class: 'upgrade-ad-dropdown__field',
            props: {
              disabled: true,
            },
            scopedSlots: {
              trigger: () => h(
                Button,
                {
                  props: {
                    type: 'is-light',
                    btnClass: 'has-text-weight-normal upgrade-ad-dropdown__field-btn',
                  },
                  attrs: { iconRight: 'chevron-down' },
                },
                [
                  h('span', { class: 'upgrade-ad-dropdown__trigger' }, [
                    h('div', {
                      class: ['icon upgrade-ad-dropdown__icon'],
                    }, [starsIcon()]),
                    h('div', { class: 'upgrade-ad-dropdown__placeholder' }, [props.placeholder]),
                  ]),
                ],
              ),
            },
          }),
        ]);
    };
  },
});

export function updateAdDropdown({ props }: { props: UpgradeAdDropdownProps }) {
  return h(UpgradeAdDropdown, { props });
}
